<ng-container *transloco="let t; scope: 'cms'">
  <section class="block trends default-padding margin--bottom-l margin--top-l">
    <div class="default-max-width centered js-slider no-overflow">
      <div class="layout-section-header">
        <h4 class="headline-second">
          {{ data.title }}
        </h4>

        <div class="layout-section-header-aside">
          <div class="swiper-control-wrapper">
            <div class="swiper-arrow swiper-arrow--prev swiper-arrow--prev-{{ data.id }}">
              <i class="icon-arrow-7"></i>
            </div>

            <div class="swiper-pagination swiper-pagination-{{ data.id }}"></div>

            <div class="swiper-arrow swiper-arrow--next swiper-arrow--next-{{ data.id }}">
              <i class="icon-arrow-7"></i>
            </div>
          </div>
        </div>
      </div>

      <swiper *ngIf="swiperConfig" [config]="swiperConfig">
        <ng-template swiperSlide *ngFor="let blogPost of data.blogposts">
          <article class="default-tile">
            <figure class="default-tile-image">
              <img [src]="blogPost.image.formats?.small?.url || blogPost.image.url" [alt]="blogPost.image.alternativeText" />
            </figure>

            <div class="default-tile-main">
              <h4 class="headline-third">
                {{ blogPost.title }}
              </h4>
              <br />
              <div class="default-text">
                {{ blogPost.description }}
              </div>
              <br />
              <div class="default-text entry-date">
                {{ blogPost.entryDate | translocoDate : { dateStyle: "full" } : "de-CH" }}
              </div>
            </div>

            <div class="default-tile-push">
              <a [href]="getBlogPostPath(blogPost)" title="" class="btn btn--outline">
                {{ t("cms.ui-blog-slider.blog-slider.read-more") }}
              </a>
            </div>
          </article>
        </ng-template>
      </swiper>
    </div>
  </section>
</ng-container>
